<template>
    <div :style="(isMobil && !isFailed)?'overflow:hidden':''"><!-- && !isFailed is a quick fix to show failed animation -->
        <EspTryAgain v-if="isTryAgain" :value="visible" :iconColor="colorTryAgain"/>
        <EspSolved v-if="isSolved || isPassedInfoSpot" :iconColor="colorSolved" :value="visible"/>
        <EspFailed v-if="isFailed" :iconColor="colorFailed" :value="visible"/>
    </div>
</template>

<script>
    import CONFIG from '@/constants/config.js';
    import {Howl} from 'howler';
    import EspTryAgain from '@/components/animation/EspTryAgain.vue'
    import EspSolved from '@/components/animation/EspSolved.vue'
    import EspFailed from '@/components/animation/EspFailed.vue'
    export default {
        components:{
            EspTryAgain,
            EspSolved,
            EspFailed
        },
        props:{
            answerResultType:{
                type:Number
            },
            value:{
                type:Boolean,
                default:false
            },
            isMobil:{
                type:Boolean,
                default:false
            },
        },
        data() {
            return {
                visible:false,
                delay:2000,
            }
        },
        watch:{
            value(val){
                this.$nextTick(()=>{
                    if(val){
                        this.showResultAnimation();
                        this.playResultSound();
                    }
                })
            }
        },
        computed: {
            isFailed(){
                return CONFIG.USER_ANSWER_RESULT_FAILED == this.answerResultType;
            },
            isTryAgain(){
                return CONFIG.USER_ANSWER_RESULT_TRY_AGAIN == this.answerResultType;
            },
            isSolved(){
                return CONFIG.USER_ANSWER_RESULT_SOLVED == this.answerResultType;
            },
            isPassedInfoSpot(){
                return CONFIG.USER_INFO_SPOT_PASSED == this.answerResultType;
            },
            adjustedDelay(){
                return (this.isSolved || this.isPassedInfoSpot)?1200:1200;
            },
            colorSolved(){
                return CONFIG.getGreen();
            },
            colorFailed(){
                return CONFIG.getRed();
            },
            colorTryAgain(){
                return CONFIG.getBlack();
            }
        },
        methods: {
            showResultAnimation(){
                this.visible=true;
                setTimeout(()=>{
                    this.visible=false;
                    this.$emit('input',this.visible);
                },this.adjustedDelay);
            },
            playSound(success,wasATrial=false){
                let soundFile = (success)?'right_answer.mp3':'final_fail.mp3'
                soundFile=(wasATrial)?'try_again.mp3':soundFile;
                const sound = new Howl({
                    src: [`/sounds/${soundFile}`],
                    volume: 0.5, // TODO - make it customizable
                });
                sound.play();
            },
            playResultSound(){
                if(this.isSolved){
                    //sound success abspielen
                  if (process.env.VUE_APP_PLAY_SUCCESS_SOUND) {
                    this.playSound(true);
                  }
                }else if(this.isPassedInfoSpot){
                  if (process.env.VUE_APP_PLAY_SUCCESS_SOUND) {
                    this.playSound(true);
                  }
                }else{
                    //sound fail / try again abspielen
                    if(this.isTryAgain){
                      if (process.env.VUE_APP_PLAY_TRY_AGAIN_SOUND) {
                        this.playSound(false, true);
                      }
                    }else{
                      if (process.env.VUE_APP_PLAY_FAILED_SOUND) {
                        this.playSound(false,false);
                      }
                    }
                }
            },
        },
    }
</script>

<style lang="scss" scoped>

</style>